import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/1ANV_logo_color.png'


const _hoisted_1 = {
  id: "footer",
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-1"
}
const _hoisted_4 = {
  class: "flex justify-center align-center mr-10",
  id: "footerLinks"
}
const _hoisted_5 = {
  href: "https://1anv.de/impressum/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_6 = {
  href: "https://1anv.de/datenschutz/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "anvLogo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)

import { useSystemStore } from "@/stores/system/SystemStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const systemStore = useSystemStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(systemStore).currentItems !== 0 && _unref(systemStore).allItems !== 0 && _unref(systemStore).currentItems !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_unref(systemStore).currentItems), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('footer.of')) + " " + _toDisplayString(_unref(systemStore).allItems) + " " + _toDisplayString(_ctx.$t('footer.results')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " ")),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('footer.imprint')), 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('footer.privacy')), 1)
    ]),
    _hoisted_7
  ]))
}
}

})